var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8ConstructionPlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 5 3 C 3.3550302 3 2 4.3550302 2 6 L 2 18 C 2 19.64497 3.3550302 21 5 21 L 22 21 L 22 5 L 8 5 L 8 3 L 5 3 z M 5 5 L 6 5 L 6 15 L 5 15 C 4.6116523 15 4.3420139 15.278986 4 15.416016 L 4 6 C 4 5.4349698 4.4349698 5 5 5 z M 8 7 L 20 7 L 20 19 L 5 19 C 4.4349698 19 4 18.56503 4 18 C 4 17.43497 4.4349698 17 5 17 L 8 17 L 8 7 z M 10 9 L 10 17 L 18 17 L 18 9 L 15 9 L 15 11 L 16 11 L 16 15 L 15 15 L 15 13 L 13 13 L 13 15 L 12 15 L 12 11 L 13 11 L 13 9 L 10 9 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ConstructionPlan);
export default __webpack_public_path__ + "static/media/icons8-construction-plan.e6bf3475.svg";
export { ForwardRef as ReactComponent };